/* not autogenerated because string.length validation does not work*/
/* eslint-disable no-multiple-empty-lines */
import * as React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Form } from "semantic-ui-react";
import { EditComponent, SaveDispatchProps, EditProps as SharedEditProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";

import { SraDepartmentEditModel, AppState } from "../model";
import { sraDepartmentSelector, basePathSelector } from "../selectors";
import { saveSraDepartment } from "../actions";

import { SraCustomer, SraCustomerState, selectors } from "../../sraCustomer";

import { EditModal } from "./EditModal";

import { push } from "redux-little-router";


export interface EditProps extends SharedEditProps<SraDepartmentEditModel> {
    open: boolean;
    sraCustomer: SraCustomer;
}

export interface DispatchProps extends SaveDispatchProps<SraDepartmentEditModel> {
    close: () => void;
}

export class EditUnconnected extends EditComponent<SraDepartmentEditModel, EditProps> {

    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>

                <Input.Text
                    value={this.state.values.name}
                    label="Name"
                    showErrors={this.state.showErrors}
                    required
                    onChange={(value, valid) => this.updateProperty("name", value, valid)}
                />
            </Form>
        );
    }

    public submit(): void {
        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }
}

function mapStateToProps(state: AppState & SraCustomerState) {
    return {
        sraCustomer: selectors.sraCustomerSelector(state),
        model: sraDepartmentSelector(state) as SraDepartmentEditModel,
        open: state.router.pathname.endsWith("/edit"),
        basePath: basePathSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (sraCustomerId: string, sraDepartment: SraDepartmentEditModel, basePath: string) =>
            dispatch(saveSraDepartment(sraCustomerId, sraDepartment, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath, {}))
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): EditProps & DispatchProps {
    return {
        sraCustomer: propsFromState.sraCustomer,
        model: propsFromState.model,
        open: propsFromState.open,
        save: (sraDepartment: SraDepartmentEditModel) => propsFromDispatch.dispatchSave(propsFromState.sraCustomer.id, sraDepartment, propsFromState.basePath),
        close: () => propsFromDispatch.dispatchClose(`${propsFromState.basePath}/${propsFromState.model.id}`)
    };
}

export const Edit = connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditModal);
